import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { IListRequestReturn } from '@/bundles/Http/interfaces/IListReturn';
import { generateParams } from '@/helpers/functions';
import { IQueryObjectParam } from '@/bundles/App/type';

export default class UserService {
  private readonly transport: HttpTransport;
  private readonly errorMapper: ErrorMapper;

  constructor(transport: HttpTransport, errorMapper: ErrorMapper) {
    this.transport = transport;
    this.errorMapper = errorMapper;
  }

  async list(params: IQueryObjectParam[]): Promise<IListRequestReturn> {
    try {
      const paramsString = generateParams(params);
      return await this.transport.get(`/user/paginated-list${paramsString}`);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async exportToCsv(params: IQueryObjectParam[]): Promise<string> {
    try {
      const paramsString = generateParams(params);
      const response = await this.transport.get(`/user/export-to-csv${paramsString}`);
      const blob = new Blob([new Uint8Array(response.data)], {
        type: 'text/csv',
      });
      return URL.createObjectURL(blob);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
